import React, { useEffect } from 'react';

import { PopupPreview } from '@confluence/template-preview';
import { LoadingTemplateCard } from '@confluence/template-card';
import { PageSegmentLoadMark } from '@confluence/browser-metrics';
import { IN_EDITOR_TEMPLATES_METRIC } from '@confluence/template-utils';

type LoadingTemplateListProps = {
	length?: number;
};

export const LoadingTemplateListCards = ({ length = 3 }: LoadingTemplateListProps) => {
	useEffect(() => {
		void PopupPreview.preload();
	}, []);

	return (
		<div data-testid="template-list-cards-loading">
			{Array(length)
				.fill(null)
				.map((_, index) => (
					<LoadingTemplateCard key={index} />
				))}
			<PageSegmentLoadMark markName="fmp" metric={IN_EDITOR_TEMPLATES_METRIC} />
		</div>
	);
};
